export default "__VITE_ASSET__6c020843__"